import React from 'react'

type Props = {}

export default function SamsaraRebels({}: Props) {
  return (
    <div><br></br><br></br><br></br><br></br><br></br><br></br>SamsaraRebels</div>
  )
}